module.exports = __webpack_public_path__ + "static/media/Hudson Westville Manhattan miljö 2022 edit.5b86aaec.jpg";